import ChatGroup from '@/chat/models/ChatGroup';
import ChatTargetContainer from '@/chat/models/ChatTargetContainer';
import ChatUser from '@/chat/models/ChatUser';
import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';

const CONTAINER_SCHEMA = {
  users: parseChatUsers,
  groups: parseGroups,
};

const USER_SCHEMA = {
  id: 'id',
  name: 'internalDialogName',
  fullName: 'name',
  avatar: 'profileImageAvatarURI',
};

const GROUP_SCHEMA = {
  id: 'id',
  name: 'internalChatName',
  description: 'description',
};

export function parseChatUsers(data: any): Array<ChatUser> {
  return parseEntities(data.outletUsers, USER_SCHEMA, ChatUser);
}

export function parseGroups(data: any): Array<ChatGroup> {
  return parseEntities(data.chatGroups, GROUP_SCHEMA, ChatGroup);
}

export function parseChatTargets(data: any): ChatTargetContainer | null {
  return parseEntity(data, CONTAINER_SCHEMA, ChatTargetContainer);
}
